/**
 * Swallows a dispatch rejection whose failure action already produced a toast elsewhere (a
 * `*Notifications` listener). Keeps the intent explicit at the call site instead of an empty
 * `.catch(() => {})`.
 */
const ignoreHandledError = (): void => {
	// Intentionally empty: the corresponding `*_FAILED` action already triggered a toast.
};

export default ignoreHandledError;
